<!--
 * @Author: wumao
 * @Date: 2021-11-25 09:04:08
 * @LastEditors: wumao
 * @LastEditTime: 2021-12-20 20:40:11
 * @Description: 第三页
-->

<template>
  <Page page="03" :companyName="resultData.orgName">
    <div class="wrapper">
      <div class="item">
        <Title text="分析说明" />
        <div class="area-border">
          <h4>企业“特”“新”能力</h4>
          <div class="line" v-for="(item, index) in resultData.analysisDescription.specialNewConditions" :key="index">
            <img v-if="item.accord == 1" class="icon" src="@/assets/images/yes.png" alt="" />
            <img v-else class="icon" src="@/assets/images/wrong.png" alt="" />
            <p>{{ item.descriptionResult }}</p>
          </div>
        </div>
      </div>
      <div class="item" v-if="resultData.policyFundingStatistics && resultData.policyFundingStatistics.policyTotal > 0">
        <Title text="当前企业可获得的其他政策资助统计" />
        <div class="area area-title">
          <div class="title">共为贵公司匹配出{{ resultData.policyFundingStatistics.policyTotal }}项可申请的政策，预计可获得{{ resultData.policyFundingStatistics.subsidyAmount }}万资金补助</div>
          <div class="pie" ref="pie"></div>
          <div class="desc">为助力您的企业发展，已为您的企业匹配其他扶持政策，可供企业参考。详情可咨询400-679-8999</div>
        </div>
      </div>
      <!-- <div class="bottom-tip">结果为测评工具和系统深度学习样本后计算的结果，仅供参考。有疑问之处可咨询公司宝专家帮您解决，详情请扫码咨询。</div>

      <div class="qr-wrapper">
        <img src="@/assets/images/qr.png" alt="">
        <p class="tip">长按二维码咨询更多内容</p>
      </div> -->

    </div>
  </Page>
</template>

<script>
import Page from './Page.vue'
import Title from './Title.vue'
import * as echarts from 'echarts'

const pieOptions = {
  // color: ['#5acbb8', '#5b8ff9', '#657798'],
  tooltip: {
    trigger: 'item',
  },
  series: [
    {
      type: 'pie',
      radius: ['50%', '80%'],
      labelLine: {
        show: true,
        length: 10,
        length2: 0,
      },
      label: {
        formatter: '{b} {d}%',
        textStyle: {
          fontSize: 8,
        },
      },
      data: [],
    },
  ],
}
export default {
  props: {
    resultData: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    pieOptions.series[0].data = this.resultData.policyFundingStatistics.partitionPieChartItemList
  },
  mounted() {
    this.initChart()
  },
  components: {
    Page,
    Title,
  },
  methods: {
    initChart() {
      let myChart = echarts.init(this.$refs.pie)
      pieOptions && myChart.setOption(pieOptions)
    },
  },
  // watch: {
  //   resultData: {
  //     handler(data) {
  //       pieOptions.series[0].data = data.policyFundingStatistics.partitionPieChartItemList
  //       this.$nextTick(() => {
  //         this.initChart()
  //       })
  //     },
  //     immediate: true,
  //     deep: true,
  //   },
  // },
}
</script>

<style lang="less" scoped>
.wrapper {
  word-break: break-all;
  word-wrap: break-word;
  .item {
    margin-bottom: 0.1rem;
    .area-border {
      margin: 0.2rem 0 0.3rem;
      padding: 0.4rem 0.3rem 0.3rem 0.3rem;
      color: #333;
      font-size: 0.24rem;
      background-color: #f7fafe;

      h4 {
        margin-bottom: 0.4rem;
        color: #333;
        font-size: 0.24rem;
        font-weight: bold;
        text-align: center;
      }
      .line {
        display: flex;
        &:not(:last-child) {
          margin-bottom: 0.2rem;
        }
        .icon {
          flex-shrink: 0;
          width: 0.24rem;
          height: 0.24rem;
          margin-right: 0.1rem;
          margin-top: 0.02rem;
        }
        p {
          line-height: 0.32rem;
          font-size: 0.24rem;
        }
      }
      .title {
        height: 0.5rem;
        line-height: 0.5rem;
        border-radius: 0.02rem;
        text-align: center;
        background-color: #fffbe6;
        font-size: 0.24rem;
        color: #a47e00;
        margin-bottom: 0.62rem;
      }
      .pie {
        width: 5rem;
        height: 2rem;
        margin: 0 auto;
      }
      .desc {
        margin-top: 0.86rem;
        text-align: center;
        color: #333;
      }
    }
    .area {
      margin: 0.2rem 0 0.3rem;
      color: #333;
      font-size: 0.24rem;
      .title {
        padding: 0.1rem;
        min-height: 0.5rem;
        line-height: 0.4rem;
        border-radius: 0.02rem;
        text-align: center;
        background-color: #fffbe6;
        font-size: 0.2rem;
        color: #a47e00;
        margin-bottom: 0.62rem;
      }
      .pie {
        width: 6.4rem;
        height: 3rem;
        margin: 0 auto;
      }
      .desc {
        margin-top: 0.86rem;
        color: #333;
      }
    }
    .area-title {
      margin-top: 0.2rem;
    }
  }
  .bottom-tip {
    color: #999;
    font-size: 0.22rem;
    margin-top: 0.1rem;
    word-break: break-all;
  }

   .qr-wrapper {
    width: 200px;
    height: 230px;
    margin: 10px auto 0;
    padding: 20px;

    img {
      width: 160px;
      height: 160px;
      box-shadow: 0 0 10px rgba(0, 114, 247, 0.14);
    }
    .tip {
      text-align: center;
      line-height: 20px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #333333;
      margin-top: 10px;
    }
  }
}
</style>
